import { UIElements } from '@ansvar-sakerhet/ui';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const FileNameText = styled(UIElements.B3)`
  flex: 0 0 90%;
  max-width: 90%;
  word-break: break-word;
`;

const IconButton = styled.button`
  display: flex;
  flex: 0 0 10%;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`;

const Input = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  padding: 0.2rem 0.4rem;
  border: 1px solid ${({ theme }) => theme.colors.black};
`;

export const S = { ...UIElements, Row, FileNameText, IconButton, Input };
